import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "tab"]
  static values = { tutorId: Number, url: String }

  connect() {
    this.loaded = false
  }

  loadMessages() {
    if (this.loaded) return

    // Show loading state
    this.contentTarget.innerHTML = '<div class="d-flex justify-content-center align-items-center py-5"><div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div></div>'

    fetch(this.urlValue)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.text()
      })
      .then(html => {
        this.contentTarget.innerHTML = html
        this.loaded = true
      })
      .catch(error => {
        console.error('Error loading messages:', error)
        this.contentTarget.innerHTML = '<div class="alert alert-danger">Error loading messages. Please try again.</div>'
      })
  }
}
